<template>
  <div class="min-table-box">
    <a-card :bordered="false" size="small">
      <a-table :columns="columns" :data-source="data" :pagination="false">
        <template slot="room" slot-scope="text">
          <a class="link-btn" @click="handleRoomTypeEdit">{{ text }}</a>
          <span style="padding-right: 4px;">#6</span>
          <a class="link-btn" @click="handleRoomUpgradesEdit">UG</a>
        </template>
        <template slot="fullName" slot-scope="text">
          <a class="link-btn" @click="handleCdbCustomerEdit">{{ text }} </a>
          <a-badge status="error" />
        </template>
        <template slot="footer">
          <div class="flex">
            <div class="flex-1" style="color: red;"><span style="vertical-align: middle;">* </span>The room doesn't meet the requirements of the guest, need to contact the guest</div>
            <div class="total">
              <div class="check-discount"><span style="color: red;">(2%)</span> off land tours paid by check</div>
              <div class="total-box"><strong>Total:</strong>$10000</div>
            </div>
          </div>
        </template>
      </a-table>
    </a-card>
    <div>
      <book-room-type
        :bookMatchTypeNum="bookMatchType" 
        @cancel="() => { this.bookMatchType = null }"
        @confirm="() => { this.bookMatchType = null }"
      />
    </div>
    <div>
      <book-room-upgrades
        :bookMatchUpgradesNum="bookMatchUpgrades" 
        @cancel="() => { this.bookMatchUpgrades = null }"
        @confirm="() => { this.bookMatchUpgrades = null }"
      />
    </div>
    <div>
      <cdb-profile
        :cdbCustomerNum="CdbCustomerProfile" 
        @cancel="() => { this.CdbCustomerProfile = null }"
        @confirm="() => { this.CdbCustomerProfile = null }"
      />
    </div>
  </div>
</template>

<script>
// import pick from 'lodash.pick'
import BookRoomType from './BookMatchRoomType'
import BookRoomUpgrades from './BookMatchRoomUpgrades'
import CdbProfile from './BookMatchCustomerProfile'

const columns = [
  {
    title: 'Room',
    dataIndex: 'room',
    scopedSlots: { customRender: 'room' }
  },
  {
    title: 'Title',
    dataIndex: 'title',
    width: 80
  },
  {
    title: 'Last, First/Middle',
    dataIndex: 'fullName',
    scopedSlots: { customRender: 'fullName' }
  },
  {
    title: 'DOB',
    dataIndex: 'birthday'
  },
  {
    title: 'Passport#',
    dataIndex: 'passportNumber'
  },
  {
    title: 'Exp.Date',
    dataIndex: 'expirationDate'
  },
  {
    title: 'Meals Restriction',
    dataIndex: 'mealsRequest'
  },
  {
    title: 'Special Request',
    dataIndex: 'specialNote'
  },
  {
    title: 'Remark',
    dataIndex: 'remark'
  },
  {
    title: 'Prices',
    dataIndex: 'prices',
    align: 'right'
  },
]

const data = [
  {
    key: '1',
    room: 'Twin',
    title: 'Mr',
    fullName: 'Yu/Peter',
    birthday: 'Sep/06/1998',
    passportNumber: '123456',
    expirationDate: 'Feb/12/2030',
    mealsRequest: 'test',
    specialNote: 'test',
    remark: 'test',
    prices: '$100',
  },
  {
    key: '2',
    room: 'Twin',
    title: 'Ms',
    fullName: 'Chang/Billy',
    birthday: 'Feb/06/1998',
    passportNumber: '666666',
    expirationDate: 'Sep/12/2030',
    mealsRequest: 'test',
    specialNote: 'test',
    remark: 'test',
    prices: '$200',
  },
  {
    key: '3',
    room: 'Twin',
    title: 'Mr',
    fullName: 'Yu/Peter',
    birthday: 'Sep/06/1998',
    passportNumber: '123456',
    expirationDate: 'Feb/12/2030',
    mealsRequest: 'test',
    specialNote: 'test',
    remark: 'test',
    prices: '$300',
  }
]

export default {
  name: 'BookMatchMain',
  components: {
    BookRoomType,
    BookRoomUpgrades,
    CdbProfile
  },
  props: {
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      data,
      columns,
      bookMatchType: null,
      bookMatchUpgrades: null,
      CdbCustomerProfile: null
    }
  },
  mounted () {
  },
  methods: {
    handleRoomTypeEdit () {
      this.bookMatchType = 'true'
    },
    handleRoomUpgradesEdit () {
      this.bookMatchUpgrades = 'true'
    },
    handleCdbCustomerEdit () {
      this.CdbCustomerProfile = 'true'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-table-footer {
  position: static;
  padding: 4px 8px 0 0;
  color: rgba(0, 0, 0, 0.85);
  background: #fff;
  border-top: 1px solid #e8e8e8;
}
.total{
  text-align: right;
}
.total > div{
  display: inline-block;
}
.total-box strong {
  margin-right: 5px;
}
.total .check-discount {
  margin-right: 30px;
}
</style>